import { render, staticRenderFns } from "./userConversionRate.vue?vue&type=template&id=06a48908&scoped=true&"
import script from "./userConversionRate.vue?vue&type=script&lang=js&"
export * from "./userConversionRate.vue?vue&type=script&lang=js&"
import style0 from "./userConversionRate.vue?vue&type=style&index=0&id=06a48908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a48908",
  null
  
)

export default component.exports